import { ModalPanel, PrimaryButton, SecondaryButton } from "@components/v2";
import { Modal } from "@shared/modal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const SyncConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: Props) => {
  return (
    <Modal
      contentClassName="max-w-[600px] h-auto"
      variant="v2"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalPanel className="text-sm">
        <div className="mb-8">
          This operation may overwrite changes you've made to quick filters.
          <br />
          Are you sure?
        </div>
        <div className="flex items-center justify-end gap-2">
          <SecondaryButton onClick={() => onClose()}>Cancel</SecondaryButton>
          <PrimaryButton onClick={() => onConfirm()}>Sync</PrimaryButton>
        </div>
      </ModalPanel>
    </Modal>
  );
};
